<template>
  <div>
    <div class="logMonitor-title">
      <div>{{ $t("alarms.log.application.application") }}</div>
      <div>
        <Button
          type="primary"
          @click="addOrUpdateHandle"
          v-hasPermission="['logs:logMonitor:add_alert_rule']"
          >{{ $t("alarms.log.application.addLogAlarm") }}</Button
        >
        <add-or-update-log-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-log-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" :animated="false">
        <TabPane :label="$t('alarms.common.alertRule')">
          <div class="logMonitor-top">
            <log-warning-search></log-warning-search>
          </div>
          <table-log-warning></table-log-warning>
        </TabPane>
        <!-- <TabPane :label="$t('alarms.instance.instanceList')">
                    <div class="logMonitor-top">
                        <log-monitor-search></log-monitor-search>
                    </div>
                    <table-log></table-log>
                </TabPane> -->
      </Tabs>
    </template>
  </div>
</template>

<script>
import LogMonitorSearch from "../log/LogMonitorSearch";
import LogWarningSearch from "../log/LogWarningSearch";
import TableLog from "../log/TableLog";
import TableLogWarning from "../log/TableLogWarning";
import AddOrUpdateLogWarning from "../log/AddOrUpdateLogWarning";

export default {
  name: "LogMonitor",
  components: {
    LogMonitorSearch,
    LogWarningSearch,
    TableLog,
    TableLogWarning,
    AddOrUpdateLogWarning
  },
  data() {
    return {
      addOrUpdateVisible: false
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    }
  }
};
</script>

<style scoped>
.logMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.logMonitor-title > div:nth-child(1) {
  float: left;
}
.logMonitor-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.logMonitor-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/logs/log/LogMonitor.vue